import { useState, useRef, useEffect } from 'react';
import {
    IonButtons,
    IonButton,
    IonHeader,
    IonContent,
    IonToolbar,
    IonTitle,
    IonPage,
    IonItem,
    IonLabel,
    IonModal,
    IonDatetimeButton,
    IonDatetime,
    IonSelect,
    IonSelectOption,
    useIonAlert,
    IonTextarea,
    useIonModal,
    IonItemGroup,
    IonIcon,
    IonInput,
    IonCheckbox,
    IonRow,
    IonFooter,
    IonPopover,
    IonSearchbar,
    IonList
} from '@ionic/react';
import { getCurrentUser, getCurrentUserUID, sendError } from '../firebase/firebase';
import { useHistory } from 'react-router';
import SmsDialog from './SmsDialog'
import dateFormat from 'dateformat';
import { getResources } from '../firebase/resources';
import { getClients, getClient } from '../firebase/clients';
import { getUser, getUsers, getActiveUsers } from '../firebase/users';
import { getSms } from '../firebase/sms';
import { OverlayEventDetail } from '@ionic/react/dist/types/components/react-component-lib/interfaces';
import { checkmark, chevronBack, people, person, returnDownBackOutline } from 'ionicons/icons';
import { getService, getServices } from '../firebase/services';
import { unregisterSmsTemplateSnapshotListener } from '../firebase/smsTemplates';
import { stringify } from 'querystring';
import EventDuplicateDialog from './EventDuplicateDialog';
import { getEventLogs } from '../firebase/events';

const EventEditor = ({
    onDismiss, initData
}: {
    onDismiss: (data: any, role: string) => void;
    initData: any
}) => {


    const [presentAlert] = useIonAlert();
    const [smsData, setSmsData] = useState({ receivers: [], date: new Date(), event: {}, clientId: '', userId: '' });
    const [refresh, setRefresh] = useState('');
    const [duplicateEventData, setDuplicateEventData] = useState<any>();

    const [comments, setComments] = useState(initData.comments ?? "")
    const [managerComments, setManagerComments] = useState(initData.managerComments ?? "")
    const [date, setDate] = useState(new Date(initData.start.getTime() - (initData.start.getTimezoneOffset() * 60000)).toISOString())
    const [time, setTime] = useState(initData.time ?? "")
    const [resourceId, setResourceId] = useState(initData.resourceId ?? "")
    //const [clientId, setClientId] = useState(initData.clientId ?? "")
    const [userId, setUserId] = useState(initData.userId ?? "")
    const [serviceId, setServiceId] = useState(initData.serviceId ?? "0")
    const [price, setPrice] = useState(initData.price ?? 0)
    const [confirmed, setConfirmed] = useState(initData.confirmed ?? false)
    const [status, setStatus] = useState(initData.status ?? 1)
    const [connectedId, setConnectedId] = useState(initData.connectedId === undefined ? false : initData.connectedId.length > 3)












    const times = [];
    for (var i = 1; i <= 96; i++) {
        times.push({ key: i * 5, value: dateFormat(new Date((i * 5 - 60) * 60 * 1000), "HH:MM") });
    }

    const resources = getResources();
    const clients = getClients();
    const users = getActiveUsers(initData.userId ?? "");
    const services = getServices();

    const [client, setClient] = useState<any | null>(initData.clientId ? getClient(initData.clientId) : null);
    const [clientsIsExpanded, setClientsIsExpanded] = useState(false);
    const [clientsSearch, setClientsSearch] = useState('');
    const [logExpanded, setLogExpanded] = useState(false);
    const [eventLogs, setEventLogs] = useState<any[]>([]);

    // Filter options based on search text (case-insensitive)
    const filteredOptions = clients.filter(c =>
        (c.surname + " " + c.name + " "
            + c.gsurname + " " + c.gname + " "
            + c.phone + " " + c.gphone
        ).toLowerCase().indexOf(clientsSearch.toLowerCase()) > -1
    );

    const handleSelect = (client: any) => {
        setClient(client);
        setClientsIsExpanded(false);
        setClientsSearch(''); // reset search text when an option is selected
    };

    const currenUser = getCurrentUser();
    const isOwner = getCurrentUserUID() === initData.userId;
    const isManager = currenUser.role === "manager";
    const isReception = currenUser.role === "reception";
    const isSave = isManager || isOwner || isReception || userId === currenUser.id || userId === undefined;
    const isComments = isManager || isReception || isOwner;

    useEffect(() => {
        if (!logExpanded || !initData?.id || !isManager) {
            return;
        }
        let active = true;
        (async () => {
            const logs = await getEventLogs(initData.id);
            if (active) {
                setEventLogs(logs);
            }
        })();
        return () => {
            active = false;
        };
    }, [logExpanded, initData?.id, isManager]);

    function formatLogFieldName(field: string) {
        switch (field) {
            case 'comments': return 'Uwagi';
            case 'managerComments': return 'Uwagi managera';
            case 'start': return 'Start';
            case 'end': return 'Koniec';
            case 'resourceId': return 'Pokój';
            case 'clientId': return 'Pacjent';
            case 'serviceId': return 'Usługa';
            case 'userId': return 'Terapeuta';
            case 'price': return 'Cena';
            case 'confirmed': return 'Potwierdzona';
            case 'status': return 'Status';
            case 'connectedId': return 'Powiązane';
            default: return field;
        }
    }

    function formatLogValue(value: any) {
        if (value === null || value === undefined || value === '') {
            return '-';
        }
        if (typeof value === 'number' && value > 1000000000000) {
            return dateFormat(new Date(value), "yyyy-mm-dd HH:MM");
        }
        if (typeof value === 'boolean') {
            return value ? 'tak' : 'nie';
        }
        return String(value);
    }

    function confirm() {
        let eventData = getEventData();
        if (eventData.resourceId === undefined || eventData.resourceId === null || eventData.resourceId.length < 3) {
            sendError("Brak wybranego pokoju");
            return;
        }
        let buttons = [];
        if (initData.connectedId !== undefined && initData.connectedId.length > 3) {
            buttons.push({
                text: 'Popraw to wydarzenie',
                role: 'confirm'
            });
            buttons.push({
                text: 'Popraw to i przyszłe',
                role: 'confirmAll'
            });
            presentAlert({
                header: 'Zapisywanie!',
                buttons: buttons,
                onDidDismiss: (e: CustomEvent) => {
                    if (e.detail.role === 'confirm') {
                        onDismiss(eventData, 'confirm');
                    }
                    if (e.detail.role === 'confirmAll') {
                        onDismiss(eventData, 'confirmAll');
                    }
                },
            })
        } else {
            onDismiss(eventData, 'confirm');
        }
    }

    function getEventData() {
        var returnData: { id: string | null, comments: any, managerComments: any, start: Date | null, time: number, resourceId: string, clientId: string, userId: string, created: any, serviceId: any, confirmed: boolean, price: number, status: number, connectedId: string } = {
            id: null,
            comments: '',
            managerComments: '',
            start: null,
            time: 0,
            resourceId: '',
            clientId: '',
            userId: '',
            serviceId: '',
            confirmed: false,
            created: undefined,
            price: 0,
            status: 1,
            connectedId: ''
        };
        returnData.id = initData.id;
        returnData.connectedId = connectedId ? initData.connectedId : "";
        returnData.comments = comments;
        returnData.managerComments = managerComments;



        //@ts-ignore
        var dateString: string = date;
        if (dateString?.includes("+")) {
            dateString = dateString.slice(0, -6);
        }
        if (dateString?.includes("Z")) {
            dateString = dateString.slice(0, -1);
        }
        var start = new Date(dateString);
        start = new Date(start.getTime());
        returnData.start = start;
        returnData.time = time;
        returnData.resourceId = resourceId;
        returnData.clientId = client ? client.id : null;
        returnData.userId = userId;
        returnData.serviceId = serviceId;
        returnData.confirmed = confirmed;
        returnData.price = price;
        returnData.status = status;
        return returnData;
    }



    function remove() {
        let buttons: any[] = [];

        if (initData.connectedId !== undefined && initData.connectedId.length > 3) {
            buttons.push({
                text: 'Usuń to wydarzenie',
                role: 'confirm'
            });
            buttons.push({
                text: 'Usuń to i przyszłe',
                role: 'confirmAll'
            });
        } else {
            buttons.push({
                text: 'Usuń',
                role: 'confirm'
            });
        }
        buttons.push({
            text: 'Anuluj',
            role: 'cancel'
        });

        presentAlert({
            header: 'Czy usunąć?!',
            buttons: buttons,
            onDidDismiss: (e: CustomEvent) => {
                if (e.detail.role === 'confirm') {
                    onDismiss({ id: initData.id, allInFuture: false }, 'remove');
                }
                if (e.detail.role === 'confirmAll') {
                    onDismiss({ id: initData.id, allInFuture: true }, 'remove');
                }
            },
        })

    }

    function cancel() {
        onDismiss(null, 'cancel')
    }


    const [presentSmsDialog, dismissSmsDialog] = useIonModal(SmsDialog, {
        initData: smsData,
        onDismiss: (data: {}, role: string) => dismissSmsDialog(data, role)
    });

    const [presentDuplicateDialog, dismissDuplicateDialog] = useIonModal(EventDuplicateDialog, {
        event: duplicateEventData,
        onDismiss: (data: {}, role: string) => dismissDuplicateDialog(data, role)
    });

    function prepareSms() {

        var dateString: string = date;
        if (dateString?.includes("+")) {
            dateString = dateString.slice(0, -6);
        }
        if (dateString?.includes("Z")) {
            dateString = dateString.slice(0, -1);
        }
        var start = new Date(dateString);
        start = new Date(start.getTime());

        //let c = getClient(clientId);
        var receivers: any = [];
        if (client !== undefined) {
            if (client.gphone !== undefined && client.gphone.length >= 9) {
                receivers.push({ name: client.gsurname + " " + client.gname, number: client.gphone });
            }
            if (client.phone !== undefined && client.phone.length >= 9) {
                receivers.push({ name: client.surname + " " + client.name, number: client.phone });
            }
        }

        if (receivers.length === 0) {
            presentAlert({
                header: 'Brak nr telefonu!',
                buttons: [
                    {
                        text: 'OK'
                    },
                ],
            })

        } else {
            setSmsData({ receivers: receivers, date: start, event: initData, clientId: client.id, userId: userId });
            presentSmsDialog({
                onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
                    //uzywam aby odswiezyl widok po wyslaniu smsa
                    setRefresh('');
                }
            });
        }


    }

    async function openSms(number: string, id: string) {
        let sms = await getSms(number, id);
        if (sms !== undefined) {
            presentAlert({
                header: 'SMS (' + (sms.tmobileId === undefined ? "?" : "v") + ")",
                subHeader: sms.sender + " => " + sms.receiver,
                message: sms.text.replace("\n", "<br>"),
                buttons: [
                    {
                        text: 'OK',
                        role: 'confirm',
                    },
                ],
            })
        }
    }

    async function duplicateEvent() {
        setDuplicateEventData(getEventData());
        presentDuplicateDialog({
            onWillDismiss: (ev: CustomEvent<OverlayEventDetail>) => {
                if (ev.detail.role === 'save') {
                    cancel();
                }
            }
        });
    }

    async function copyEventId() {
        if (!initData?.id) {
            return;
        }
        try {
            await navigator.clipboard.writeText(String(initData.id));
            presentAlert({
                header: 'Skopiowano',
                message: 'ID wydarzenia zostało skopiowane do schowka.',
                buttons: [{ text: 'OK' }]
            });
        } catch (error) {
            presentAlert({
                header: 'Błąd',
                message: 'Nie udało się skopiować ID wydarzenia.',
                buttons: [{ text: 'OK' }]
            });
        }
    }

    const history = useHistory();

    function openClientEditor() {
        //if (clientId.length > 3) {
        if (client != null) {
            onDismiss("/app/clients/" + client.id, 'redirect')
        }
    }

    const statuses = [{ id: 1, value: "umówiony" }, { id: 2, value: "odwołany (klient)" }, { id: 3, value: "odwołany (terapeuta)" }, { id: 4, value: "nieobecny" }, { id: 5, value: "zrealizowany" }];

    const ownerUser = initData.owner ? getUser(initData.owner) : null;
    const ownerName = ownerUser
        ? (`${ownerUser.name ?? ''} ${ownerUser.surname ?? ''}`.trim() || ownerUser.email || initData.owner)
        : (initData.owner ?? '');

    function formatMetaDate(value: any) {
        if (!value) {
            return '';
        }
        try {
            if (typeof value.toDate === 'function') {
                return dateFormat(value.toDate(), "yyyy-mm-dd HH:MM");
            }
            const dateValue = value instanceof Date ? value : new Date(value);
            if (Number.isNaN(dateValue.getTime())) {
                return '';
            }
            return dateFormat(dateValue, "yyyy-mm-dd HH:MM");
        } catch (error) {
            return '';
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonButton color="medium" onClick={() => cancel()}>
                            <IonIcon icon={chevronBack} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>{initData.id !== undefined ? "Edycja Wydarzenia" : "Nowe wydarzenie"}{refresh}</IonTitle>
                    {
                        (isSave) ?
                            <IonButtons slot="end">
                                <IonButton onClick={() => confirm()}><IonIcon icon={checkmark} /></IonButton>
                            </IonButtons>
                            : ""

                    }
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding">
                {/* <IonItem>
                    <IonLabel>Pacjent</IonLabel>
                    <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={clientId} onIonChange={(e) => setClientId(e.detail.value)} placeholder="Wybierz pacjenta">
                        <IonSelectOption value="0"></IonSelectOption>
                        {clients.map(c => {
                            return <IonSelectOption key={c.id} value={c.id}>{c.surname + " " + c.name}</IonSelectOption>

                        })}

                    </IonSelect>
                    <IonButton slot='end' onClick={() => { openClientEditor() }} ><IonIcon icon={person} /></IonButton>

                </IonItem> */}

                <IonItem>
                    <IonLabel >Pacjent</IonLabel>
                    <IonItem button onClick={() => setClientsIsExpanded(!clientsIsExpanded)}>
                        <IonLabel style={{ textAlign: "right" }}>
                            {client ? client.surname + " " + client.name : 'wybierz...'}
                        </IonLabel>
                    </IonItem>
                    <IonButton slot='end' onClick={() => { openClientEditor() }} ><IonIcon icon={person} /></IonButton>

                </IonItem>

                <div style={{ position: 'relative' }}>
                    {clientsIsExpanded && (
                        <div
                            style={{
                                position: 'absolute',
                                top: '100%',
                                left: 0,
                                right: 0,
                                background: 'white',
                                border: '1px solid #ccc',
                                borderRadius: '4px',
                                zIndex: 10,
                                marginTop: '4px'
                            }}
                        >
                            <IonSearchbar
                                value={clientsSearch}
                                onIonChange={e => setClientsSearch(e.detail.value!)}
                                placeholder=""
                                debounce={300}
                            />
                            <IonList>
                                <IonItem key={"usuń"} button onClick={() => handleSelect(null)}>
                                    <IonLabel>usuń...</IonLabel>
                                </IonItem>
                                {filteredOptions.map(c => (
                                    <IonItem key={c.id} button onClick={() => handleSelect(c)}>
                                        <IonLabel>{c.surname + " " + c.name}</IonLabel>
                                    </IonItem>
                                ))}
                            </IonList>
                        </div>
                    )}
                </div>



                <IonItem hidden={!isComments}>
                    <IonTextarea placeholder="Uwagi" autoGrow={true} value={comments} onIonChange={(e) => setComments(e.detail.value)}></IonTextarea>
                </IonItem>
                <IonItem hidden={!isManager}>
                    <IonTextarea style={{ '--color': '#003399' }} placeholder="Manager" autoGrow={true} value={managerComments} onIonChange={(e) => setManagerComments(e.detail.value)}></IonTextarea>
                </IonItem>

                <IonItem>
                    <IonLabel>Usługa</IonLabel>
                    <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={serviceId} onIonChange={(e) => {
                        setServiceId(e.detail.value);
                        const service = getService(e.detail.value);
                        if (service !== undefined) {
                            setPrice(service.price);
                            setTime(service.time);
                        }
                    }
                    } placeholder="Wybierz usługę">
                        <IonSelectOption value="0"></IonSelectOption>
                        {services.map(s => {
                            return <IonSelectOption key={s.id} value={s.id}>{s.name}</IonSelectOption>
                        })}
                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>Cena</IonLabel>
                    <IonInput style={{ textAlign: "right" }} slot="end" placeholder="Cena" type="number" value={price} onIonChange={(e) => setPrice(e.detail.value)}></IonInput>
                </IonItem>
                <IonItem>
                    <IonLabel >Data</IonLabel>
                    <IonDatetimeButton datetime="datetime-date"></IonDatetimeButton>
                    <IonDatetimeButton datetime="datetime-time"></IonDatetimeButton>
                </IonItem>

                <IonItem>
                    <IonLabel>Czas</IonLabel>
                    <IonSelect interface="popover" value={time} onIonChange={(e) => setTime(e.detail.value)} placeholder="Czas">
                        {times.map(item => {
                            return <IonSelectOption key={item.key} value={item.key}>{item.value}</IonSelectOption>
                        })}

                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>Terapeuta</IonLabel>
                    <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={userId} onIonChange={(e) => setUserId(e.detail.value)} placeholder="Wybierz terapeute">

                        {users.map(u => {
                            //if (currenUser.role === "manager" || currenUser.id === u.id) {
                            return <IonSelectOption key={u.id} value={u.id}>{u.surname + " " + u.name}</IonSelectOption>
                            //}
                        })}

                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel>Pokój</IonLabel>
                    <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={resourceId} onIonChange={(e) => setResourceId(e.detail.value)} placeholder="Wybierz pokój">
                        {resources.map(item => {
                            if (getCurrentUser().resources.includes(item.resourceId))
                                return <IonSelectOption key={item.resourceId} value={item.resourceId}>{item.resourceTitle}</IonSelectOption>
                        })}

                    </IonSelect>
                </IonItem>
                <IonItem>
                    <IonLabel >Potwierdzona</IonLabel>
                    <IonCheckbox checked={confirmed} onIonChange={(e) => setConfirmed(e.detail.checked)} />
                    <div style={{ display: "flex", minWidth: "20px", color: "darkgray", fontSize: "10px", position: "absolute", top: "2px", right: "20px" }}>
                        {initData.confirmedDate != null ? dateFormat(initData.confirmedDate, "yyyy-mm-dd HH:MM") : ""}
                        {isManager && initData.confirmedIp != null ? " [" + initData.confirmedIp + "]" : ""}
                    </div>


                </IonItem>

                <IonItem>
                    <IonLabel>Status</IonLabel>
                    <IonSelect style={{ maxWidth: "100%" }} interface="popover" value={status} onIonChange={(e) => setStatus(e.detail.value)} placeholder="Status">
                        {statuses.map(s => {
                            return <IonSelectOption key={s.id} value={s.id}>{s.value}</IonSelectOption>
                        })}

                    </IonSelect>
                </IonItem>
                {initData.id !== undefined && isManager && (
                    <>
                        <IonItem button onClick={() => setLogExpanded((prev) => !prev)}>
                            <IonLabel>log {logExpanded ? '▲' : '▼'}</IonLabel>
                        </IonItem>
                        {logExpanded && (
                            <>
                                <IonItem>
                                    <IonLabel>ID</IonLabel>
                                    <IonInput readonly value={initData.id}></IonInput>
                                    <IonButton slot="end" onClick={() => copyEventId()}>kopiuj</IonButton>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Data utworzenia</IonLabel>
                                    <IonLabel>{formatMetaDate(initData.created)}</IonLabel>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Utworzył</IonLabel>
                                    <IonLabel>{ownerName}</IonLabel>
                                </IonItem>
                                <IonItem>
                                    <IonLabel>Data poprawy</IonLabel>
                                    <IonLabel>{formatMetaDate(initData.updated)}</IonLabel>
                                </IonItem>
                                <IonItem>
                                    <IonLabel style={{ fontWeight: 'bold' }}>Historia zmian</IonLabel>
                                </IonItem>
                                {eventLogs.length === 0 && (
                                    <IonItem>
                                        <IonLabel>Brak wpisów log.</IonLabel>
                                    </IonItem>
                                )}
                                {eventLogs.map((item) => {
                                    const user = item.owner ? getUser(item.owner) : null;
                                    const userName = user
                                        ? (`${user.name ?? ''} ${user.surname ?? ''}`.trim() || user.email || item.owner)
                                        : (item.owner ?? '-');
                                    const changesText = (item.changes ?? [])
                                        .map((change: any) => `${formatLogFieldName(change.field)}: ${formatLogValue(change.previous)} -> ${formatLogValue(change.next)}`)
                                        .join(' | ');
                                    return (
                                        <IonItem key={item.id}>
                                            <IonLabel>
                                                <div>{dateFormat(item.created ?? new Date(), "yyyy-mm-dd HH:MM")} | {userName}</div>
                                                <div style={{ fontSize: '12px', color: '#666' }}>{changesText || 'bez zmian'}</div>
                                            </IonLabel>
                                        </IonItem>
                                    );
                                })}
                            </>
                        )}
                    </>
                )}
                <IonItem hidden={!getCurrentUser().sms || getCurrentUser().smsTemplates.length == 0 || initData.id === undefined}>
                    <IonButton color="primary" onClick={() => prepareSms()}>sms</IonButton>
                    <IonItemGroup className="ion-padding">
                        {initData.smsList !== undefined ? initData.smsList.map((item: any) => { return <IonButton size="small" onClick={(e) => { openSms(item.number, item.id) }}>{dateFormat(new Date(item.date), "yyyy-mm-dd HH:MM")}</IonButton> }) : ''}
                    </IonItemGroup>
                </IonItem>
                <IonItem hidden={initData.id === undefined}>
                    <IonButton color="primary" onClick={() => duplicateEvent()}>powiel wydarzenie</IonButton>
                    <IonItem hidden={initData.connectedId === undefined || initData.connectedId.length < 3} slot="end">
                        <IonLabel>Powiązane &nbsp;</IonLabel>
                        <IonCheckbox checked={connectedId} onIonChange={(e) => setConnectedId(e.detail.checked)} />
                    </IonItem>

                </IonItem>






            </IonContent>
            <IonFooter>
                {initData.id !== undefined && (currenUser.role === "manager" || currenUser.role === "reception" || initData.userId === currenUser.id) && client === null && comments === "" && managerComments === "" ? <div><IonButton size="small" color="danger" onClick={() => remove()}>usuń</IonButton><br /><br /></div> : ""}
            </IonFooter>

            <IonModal keepContentsMounted={true}>
                <IonDatetime id="datetime-date" presentation="date" value={date} onIonChange={(e) => setDate(e.detail.value + "")} minuteValues="0,5,10,15,20,25,30,35,40,45,50,55"></IonDatetime>
            </IonModal>
            <IonModal keepContentsMounted={true}>
                <IonDatetime id="datetime-time" presentation="time" value={date} onIonChange={(e) => setDate(e.detail.value + "")} minuteValues="0,5,10,15,20,25,30,35,40,45,50,55"></IonDatetime>
            </IonModal>
            {/* Popover containing the search bar and options list */}

        </IonPage>
    );
};

export default EventEditor;



